module.exports = [{
      plugin: require('/codebuild/output/src433586803/src/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
